import React, { useState, useContext } from 'react';
import Context from "../context/context";
import classnames from 'classnames';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {format_date_datepicker} from '../helpers/dates'
const Dates = props => {
  const {endDateFormatted, setEndDateFormatted, startDateFormatted, setStartDateFormatted, setCurrentPage, startDateOpen, setStartDateOpen, endDateOpen, setEndDateOpen, startDate, setStartDate, endDate, setEndDate, activeFilters, setActiveFilters, filterNav, setFilterNav, setNavStatus} = useContext(Context);
  const {data, active, multi, handleClose, clearAllFilters, widget} = props;
  const [open, setOpen] = useState(false);

  const [endDateShowing, setEndDateShowing] = useState(false);

  const toggleEndDateShowing = () => {
    setEndDateShowing(!endDateShowing);
  }

  let body = document.body;
  let minDate = new Date();


  const clearTheseFilters = () => {
    const a = {...activeFilters};
    const activeFilter = a[data.name];
    activeFilter.value = [false, false];
    activeFilter.selectedTitles = [];
    
    setStartDate(false);
    setStartDateFormatted('Date');
    setEndDate(false);
    setEndDateFormatted('Date');
    setActiveFilters(a);
    setCurrentPage(1)
  }

  const clearThisFilter = (type) => {
    const a = {...activeFilters};
    const activeFilter = a[data.name];
    if (type == "start"){
      activeFilter.value = [false, false];
      setStartDate(false);
      setStartDateFormatted('Date');
      setEndDate(false);
      setEndDateFormatted('Date');
    }
    if (type == "end"){
      activeFilter.value[1] = false;
      setEndDate(false);
      setEndDateFormatted('Date');
    }
    activeFilter.selectedTitles = [];

    setActiveFilters(a);
    setCurrentPage(1);
  }

  const handleViewResults = () => {
    handleClose();
    let updatedFilterNav = [...filterNav];
    updatedFilterNav.map((nav, i) => {
      nav.open = false;
    })
    setFilterNav(updatedFilterNav)
    setNavStatus(false);
    const body = document.querySelector('body');
    body.classList.remove('filters-open');
  }


  const toggleStartDateOpen = () => {
    setStartDateOpen(!startDateOpen);
    setEndDateOpen(false);
  }

  const toggleEndDateOpen = () => {
    setEndDateOpen(!endDateOpen);
    setStartDateOpen(false)
  }
  const handleChange = (date, type) => {
    const filter = {...activeFilters[data.name]};


    
    if (type == "start"){

      filter.value[0] = new Date(date.setHours(0,0,0,0));

      setStartDate(date);
      setStartDateFormatted(format_date_datepicker(date));

      if (filter.value[1]){

        let start_timestamp = date.setHours(0,0,0,0),
            end_timestamp = filter.value[1].setHours(0,0,0,0);

        // if (start_timestamp > end_timestamp){
        //   console.log('update date', start_timestamp, end_timestamp)
        //   setEndDate(date);
        //   setEndDateFormatted(format_date_datepicker(date));
        // }
        filter.value[1] = new Date(date.setHours(0,0,0,0));

        setEndDate(date);
        setEndDateFormatted(format_date_datepicker(date));
      } else {
        filter.value[1] = new Date(date.setHours(0,0,0,0));

        setEndDate(date);
        setEndDateFormatted(format_date_datepicker(date));
      }
    }

    if (type == "end"){
      filter.value[1] = new Date(date.setHours(0,0,0,0));
      setEndDate(date);
      setEndDateFormatted(format_date_datepicker(date));
    }

    if (activeFilters && activeFilters.top_filter && Object.keys(activeFilters.top_filter).length > 0) {
      const top_filter = {...activeFilters['top_filter']};
      top_filter.value = "all";
      setActiveFilters({...activeFilters,
        [data.name]: filter,
        ['top_filter'] : top_filter
      });
    } else {
      setActiveFilters({...activeFilters,
        [data.name]: filter
      });
    }





    setCurrentPage(1);
    setStartDateOpen(false);
    setEndDateOpen(false);
  }

  return (
    <>
      <fieldset className={classnames('form-section draggable', {
        active: open,
        })} >

<legend onClick={() => setOpen(!open)}>{data.title}</legend>

        <div className="form-row-container" >
          <div className="form-row" >
            <div className="datepicker-wrapper" >

              <div className="form-element form-element-datepicker date-from full" >
                <label class="datepicker-button-title">Select a start date</label>
              </div>

              <div className="datepicker-container">
          
                <DatePicker
                  showIcon
                  selected={startDate}
                  minDate={minDate}
                  onChange={(date) => handleChange(date, 'start')}
                  inline
                />

                <div class="btn-wrap">
                  <button className="button-apply" onClick={() => toggleStartDateOpen()}>Apply</button>
                  <button class="clear-date" onClick={() => clearThisFilter('start')}>Reset these filters</button>
                </div>

              </div>

              <div className="form-element form-element-datepicker date-from full" >
                <button onClick={toggleEndDateShowing} class="datepicker-button-title is-button">Select an end date</button>




              </div>
              {endDateShowing &&
                <>
      

                <div className={classnames(' datepicker-container', {
                  active: endDateOpen && widget.open,
                })}>

                  <DatePicker
                    showIcon
                    selected={endDate}
                    minDate={(startDate) ? startDate : minDate }
                    onChange={(date) => handleChange(date, 'end')}
                    inline
                  />

                  <div class="btn-wrap">
                  <button className="button-apply" onClick={() => toggleEndDateOpen()}>Apply</button>

                    <button class="clear-date" onClick={() => clearThisFilter('end')}>Reset these filters</button>
                  </div>


                </div>
                </>

                }

            </div>
          </div>
        </div>

    


      </fieldset>




      </>
  )
}

export default Dates;
